export default "__VITE_ASSET__2Q85_42J__"